export class ExportDashboardState {
  /**
   * @var {set}
   */
  unrenderedWidgets;

  /**
   * @var {}
   */
  readyToPaginateWidgets = {};

  /**
   * @type {number}
   */
  paginationTarget = 0;

  /**
   * @type {boolean}
   */
  isReadyToPaginate = false;

  /**
   * @type {{}}
   */
  paginationQueue = {};

  /**
   * @type {number}
   */
  measuredElementsCounter = 0;

  /**
   * @type {{}}
   */
  measuredElements = {};

  /**
   * @type {boolean}
   */
  isReadyToDisplay = false;

  /**
   * @type {{}}
   */
  executiveSummaryQueue = [];

  /**
   * @type {{}}
   */
  paginationPerLayout = {};

  constructor() {
    this.unrenderedWidgets = new Set();
  }
}
